import { render, staticRenderFns } from "./School.vue?vue&type=template&id=897b6e9e&scoped=true&"
import script from "./School.vue?vue&type=script&lang=ts&"
export * from "./School.vue?vue&type=script&lang=ts&"
import style0 from "./School.vue?vue&type=style&index=0&id=897b6e9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897b6e9e",
  null
  
)

component.options.__file = "School.vue"
export default component.exports